import React, { useState } from 'react';
import { resetPassword } from 'aws-amplify/auth';
import { userAppContext } from '../../context/Context';
import NewPassword from './NewPassword';
import SharedButton from '@/global/Button/Button';

export default function Reset({ setReset }) {
  const [errorMessage, setErrorMessage] = useState('');
  const { setIsAuthenticated, setAuthorization, setGroups } = userAppContext();
  const [name, setName] = useState('');
  const [newPassword, setNewPassword] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async evt => {
    evt.preventDefault();
    if (!name) {
      setErrorMessage('Please enter your email');
      return;
    }

    if (!validateInput(name)) {
      setErrorMessage('Invalid email format');
      return;
    }

    try {
      setErrorMessage('');
      await resetPassword({ username: name });
      setNewPassword(true);
      setIsSubmitted(true);
    } catch (error) {
      setErrorMessage(error.message);
      setIsSubmitted(false);
    }
  };

  const validateInput = inputValue => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue.trim());
  };

  const handleBlur = event => {
    if (!validateInput(event.target.value)) {
      setErrorMessage('Invalid email format');
    } else {
      setErrorMessage('');
    }
  };

  return newPassword ? (
    <NewPassword setReset={setReset} name={name} />
  ) : (
    <div className="login-container mb-5">
      <div className="form-apply w-full max-w-lg rounded-2xl text-center">
        <form onSubmit={handleSubmit}>
          <h3 className="text-pink font-bold mb-4">RESET PASSWORD</h3>
          <div className="text-left w-full" data-validate="User Name is required">
            <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">Email:</label>
            <div>
              <input
                onChange={event => setName(event.target.value)}
                onBlur={handleBlur}
                className="form-input"
                type="email"
                name="email"
                placeholder="Email..."
              />
            </div>
          </div>
          <div className="text-right">
            <a
              className="text-gray-600 hover:text-blue-950 text-xs mr-2"
              href="true"
              onClick={evt => {
                evt.preventDefault();
                setReset(false);
              }}
            >
              Cancel
            </a>
          </div>
          <div className="container-contact100-form-btn mt-4">
            <SharedButton type="submit" variant="primary" className="w-full">
              Send
            </SharedButton>
          </div>
          <div>
            <div className="mt-3">{errorMessage && <p className="form-error">{errorMessage}</p>}</div>
            {isSubmitted && <p className="mt-3">We will send the confirmation code to your email</p>}
          </div>
        </form>
      </div>
    </div>
  );
}
